import { Capacitor } from "@capacitor/core";
import axios from "axios";

// On native platforms (iOS/Android), the app loads from bundled assets
// so relative API calls (e.g. /api/v1/...) won't resolve without a base URL.
// On web, relative URLs work via the proxy (dev) or same-origin (production).
const API_BASE_URL = "https://kamracarpool.vercel.app";

if (Capacitor.isNativePlatform()) {
  axios.defaults.baseURL = API_BASE_URL;
  axios.defaults.withCredentials = true;
}
